export default __webpack_public_path__ + "static/ltya-color-325ddc2e12e0ce759798ad5d6a891bae.png";